import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const VirtualCardDisplay = ({ cardStatus, availableBalance, spendingLimit }) => {
  const [showCardNumber, setShowCardNumber] = useState(false);
  const [showCVV, setShowCVV] = useState(false);

  const cardNumber = '4532 •••• •••• 8765';
  const fullCardNumber = '4532 1234 5678 8765';
  const expiryDate = '12/28';
  const cvv = '***';
  const fullCVV = '123';
  const cardholderName = 'JOHN DOE';

  return (
    <div className="card">
      <div className="card-header">
        <div>
          <h2 className="card-title">Virtual Visa Card</h2>
          <p className="card-description">Your digital payment card</p>
        </div>
        <div className={`flex items-center gap-2 px-3 py-1.5 rounded-lg ${
          cardStatus === 'active' ? 'bg-success/10' : 'bg-error/10'
        }`}>
          <div className={`w-2 h-2 rounded-full ${
            cardStatus === 'active' ? 'bg-success' : 'bg-error'
          }`} />
          <span className={`text-sm font-semibold capitalize ${
            cardStatus === 'active' ? 'text-success' : 'text-error'
          }`}>
            {cardStatus}
          </span>
        </div>
      </div>
      <div className="card-content">
        {/* 3D Card Display */}
        <div className="relative">
          <div className={`relative w-full aspect-[1.586/1] rounded-2xl p-6 shadow-2xl transition-all duration-300 ${
            cardStatus === 'frozen' ? 'opacity-60 grayscale' : ''
          }`}
            style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              transform: 'perspective(1000px) rotateY(-5deg) rotateX(5deg)',
              transformStyle: 'preserve-3d'
            }}
          >
            {/* Card Overlay Pattern */}
            <div className="absolute inset-0 rounded-2xl opacity-10"
              style={{
                backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px)',
                backgroundSize: '20px 20px'
              }}
            />

            {/* Visa Logo */}
            <div className="absolute top-6 right-6">
              <div className="text-white font-bold text-2xl italic">VISA</div>
            </div>

            {/* Chip */}
            <div className="absolute top-16 left-6">
              <div className="w-12 h-10 bg-gradient-to-br from-yellow-200 to-yellow-400 rounded-md">
                <div className="grid grid-cols-3 gap-0.5 p-1.5 h-full">
                  {[...Array(9)]?.map((_, i) => (
                    <div key={i} className="bg-yellow-600/30 rounded-sm" />
                  ))}
                </div>
              </div>
            </div>

            {/* Card Number */}
            <div className="absolute top-32 left-6 right-6">
              <div className="flex items-center justify-between mb-2">
                <p className="text-white text-xl font-mono tracking-wider">
                  {showCardNumber ? fullCardNumber : cardNumber}
                </p>
                <button
                  onClick={() => setShowCardNumber(!showCardNumber)}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  <Icon name={showCardNumber ? 'EyeOff' : 'Eye'} size={18} />
                </button>
              </div>
            </div>

            {/* Cardholder and Expiry */}
            <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
              <div>
                <p className="text-white/70 text-xs mb-1">CARDHOLDER</p>
                <p className="text-white text-sm font-semibold tracking-wide">{cardholderName}</p>
              </div>
              <div className="text-right">
                <p className="text-white/70 text-xs mb-1">EXPIRES</p>
                <p className="text-white text-sm font-semibold">{expiryDate}</p>
              </div>
            </div>

            {/* CVV (Back of card effect) */}
            <div className="absolute top-6 left-6">
              <div className="flex items-center gap-2">
                <p className="text-white/70 text-xs">CVV:</p>
                <p className="text-white text-sm font-mono">
                  {showCVV ? fullCVV : cvv}
                </p>
                <button
                  onClick={() => setShowCVV(!showCVV)}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  <Icon name={showCVV ? 'EyeOff' : 'Eye'} size={14} />
                </button>
              </div>
            </div>

            {/* Frozen Overlay */}
            {cardStatus === 'frozen' && (
              <div className="absolute inset-0 flex items-center justify-center bg-black/40 rounded-2xl backdrop-blur-sm">
                <div className="text-center">
                  <Icon name="Lock" size={48} className="text-white mx-auto mb-2" />
                  <p className="text-white font-semibold">Card Frozen</p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Card Info */}
        <div className="grid grid-cols-2 gap-4 mt-6">
          <div className="p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center gap-2 mb-1">
              <Icon name="Wallet" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">Available</span>
            </div>
            <p className="text-xl font-bold text-foreground">
              ${availableBalance?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
          </div>
          <div className="p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center gap-2 mb-1">
              <Icon name="TrendingUp" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">Limit</span>
            </div>
            <p className="text-xl font-bold text-foreground">
              ${spendingLimit?.toLocaleString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VirtualCardDisplay;